function validPeriodEnd(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value) && value > 0 &&
    Number.isFinite(new Date(value * 1000).getTime());
}

export function getSubscriptionPeriodEnd(subscription: {
  items?: { data?: { current_period_end?: unknown }[] };
  current_period_end?: unknown;
}): number | null {
  const dates = subscription.items?.data?.map(item => item.current_period_end).filter(validPeriodEnd) ?? [];
  // Different item periods must not promise full access beyond the first end.
  if (dates.length) return Math.min(...dates);
  return validPeriodEnd(subscription.current_period_end) ? subscription.current_period_end : null;
}

export function formatBillingEndDate(value: unknown): string | null {
  if (!validPeriodEnd(value)) return null;
  return new Date(value * 1000).toLocaleDateString("en-US", {
    month: "short", day: "numeric", year: "numeric",
  });
}

export function getCancellationMessage(periodEnd: unknown): string {
  const date = formatBillingEndDate(periodEnd);
  return date
    ? `Your subscription is cancelled. You keep full access until ${date}.`
    : "Your subscription is cancelled. You keep full access until the end of your current billing period.";
}
